/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to save MCP server." |
*
* @param {Mcp_Servers_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_save_error = /** @type {((inputs?: Mcp_Servers_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("MCP-Server konnte nicht gespeichert werden.")
	return /** @type {LocalizedString} */ ("Failed to save MCP server.")
});